import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  BASE_URL,
  URL_SHIFTS,
  URL_CLIENT,
  URL_SEARCH_ROLES,
  URL_SEARCH_USERS,
  URL_SEARCH_PROJECTS,
  URL_RISK,
  URL_SEARCH_BUDGET,
  URL_BUDGETS,
  URL_SEARCH_CHANGE_REQUEST,
  URL_SEARCH_MEETING_REGISTERY,
  URL_PROGRAM,
  URL_SEARCH_RISK,
  URL_PROJECT_RESOURCES,
  URL_SEARCH_COMMUNICATION_PLAN,
  URL_PROJECTS,
  URL_TASK,
  URL_SEARCH_TASK,
  URL_SEARCH_CLIENT,
  URL_CLIENT_PORTFOLIOS,
  URL_CLIENT_PROGRAMS,
  URL_SEARCH_PORTFOLIO,
  URL_PORTFOLIO,
  URL_CLIENT_RESOURCES,
  URL_PROGRAM_RESOURCES,
  URL_PORTFOLIO_RESOURCES,
  URL_SEARCH_BUDGET_ONLY,
  URL_PROJECT_INVOICE_REGISTRY,
  URL_PROJECT_PURCHASE_ORDERS,
  URL_PROJECT_DECISION_LOG,
  URL_PROGRAM_DECISION_LOG,
} from "../../store/services/URL";
import moment from "moment";
import styles from "./HeaderStyles.module.scss";
import { SearchIcon } from "../../modules/default-svg";
import _ from 'lodash';

const Search = (props) => {
  const {
    parentType,
    notifications,
    reminders,
    type,
    searchResult,
    customClassSearch,
    clientId,
    portfolioId,
    programId,
    projectId,
    scopeId,
    searchWd,
    healthData,
    severityFilter,
    isDisabled,
    triggerSearch
  } = props;
  const [search, setSearch] = useState("");
  const handleChange = (value) => {
    const searchTerm = value && value?.trim() !== ""? value?.trim(): null;
    setSearch(value);
    switch (type) {
      case "Notification": {
        if (searchTerm) {
          const data = notifications.filter((n) => {
            if (n.title.includes("<@link:")) {
              const regex = /<@link:(\w+):([a-f0-9\-]+)@>/g;
              const name = n.title.replace(regex, (match, type, id) => {
                let entityName;
                if (n.links.length > 0) {
                  entityName = n.links
                    .filter((e) => e.linkId === id)
                    .map((e) => e.linkName);
                  return entityName;
                }
              });
              return name?.toLowerCase().includes(searchTerm);
            } else if (n.notes.includes("<@link:")) {
              const regex = /<@link:(\w+):([a-f0-9\-]+)@>/g;
              const name = n.notes.replace(regex, (match, type, id) => {
                let entityName;
                if (n.links.length > 0) {
                  entityName = n.links
                    .filter((e) => e.linkId === id)
                    .map((e) => e.linkName);
                  return entityName;
                }
              });
              return name?.toLowerCase().includes(searchTerm);
            } else {
              return n.title?.toLowerCase().includes(searchTerm);
            }
          });
          // const data = notifications.filter((n) => n.title?.toLowerCase().includes(value));
          searchResult(data);
        } else {
          searchResult(notifications);
        }
        break;
      }
      case "Reminder": {
        if (searchTerm) {
          const data = reminders?.filter((n) => {
            if (n.title.includes("<@link:")) {
              const regex = /<@link:(\w+):([a-f0-9\-]+)@>/g;
              const name = n.title.replace(regex, (match, type, id) => {
                let entityName;
                if (n.links.length > 0) {
                  entityName = n.links
                    .filter((e) => e.linkId === id)
                    .map((e) => e.linkName);
                  return entityName;
                }
              });
              return name?.toLowerCase().includes(searchTerm);
            } else if (n.notes.includes("<@link:")) {
              const regex = /<@link:(\w+):([a-f0-9\-]+)@>/g;
              const name = n.notes.replace(regex, (match, type, id) => {
                let entityName;
                if (n.links.length > 0) {
                  entityName = n.links
                    .filter((e) => e.linkId === id)
                    .map((e) => e.linkName);
                  return entityName;
                }
              });
              return name?.toLowerCase().includes(searchTerm);
            } else {
              return n.title?.toLowerCase().includes(searchTerm);
            }
          });
          // const data = reminders?.filter((n) => n.title?.toLowerCase().includes(value));
          searchResult(data);
        } else {
          searchResult(reminders);
        }
        break;
      }
      case "HealthStatus": {
        if (searchTerm) {
          const data = healthData?.filter((n) => {
            return n.name?.toLowerCase().includes(searchTerm);
          });
          searchResult(data);
        } else {
          searchResult(null);
        }
        break;
      }
      default: {
        /*const path = getPath();
        path !== "" && fetchRecords(path, value);*/
        break;
      }
    }
    handleSearch(searchTerm);
  };

  const triggerSearchDebounced = useCallback(
    _.debounce((value) => {
      triggerSearch(value);
    }, 500),
    [triggerSearch]
  );

  useEffect(() => {
    return () => {
      triggerSearchDebounced.cancel();
    };
  }, [triggerSearchDebounced]);


  const handleSearch = (value) => {
    if (!value) {
      triggerSearch(value);
      triggerSearchDebounced.cancel();
    } else {
      triggerSearchDebounced(value);
    }
  }
  /*const fetchRecords = (path, value) => {
    try {
      const token = localStorage.getItem("accessToken");
      const headers = {
        Authorization: `Bearer ${token.replace(/"/g, "")}`,
      };
      console.log("path", `${path}${value}`);
      axios
        .get(`${path}${value}`, { headers })
        .then((res) => {
          if (parentType === "Shift") {
            if (value) {
              searchResult(res.data);
            } else {
              searchResult([]);
            }
          } else {
            searchResult(res.data);
          }
        })
        .catch(() => {});
    } catch (e) {}
  };*/

  /*
  const getPath = () => {
    switch (type) {
      case "Role":
        return URL_SEARCH_ROLES;
      case "Resource":
        return URL_SEARCH_USERS;
      case "Budget": {
        if (parentType === "Budget") return `${URL_BUDGETS}?searchTerm=`;
        if (parentType === "Project")
          return `${URL_PROJECTS}/${projectId}${URL_SEARCH_BUDGET_ONLY}`;
        if (parentType === "Program")
          return `${URL_PROGRAM}${programId}${URL_SEARCH_BUDGET}`;
        if (parentType === "Portfolio")
          return `${URL_PORTFOLIO}/${portfolioId}${URL_SEARCH_BUDGET}`;
        break;
      }
      case "Change Request": {
        if (parentType === "Change Request")
          return `${BASE_URL}${URL_SEARCH_CHANGE_REQUEST}`;
        if (parentType === "Project")
          return `${URL_PROJECTS}/${projectId}${URL_SEARCH_CHANGE_REQUEST}`;
        if (parentType === "Program")
          return `${URL_PROGRAM}${programId}${URL_SEARCH_CHANGE_REQUEST}`;
        if (parentType === "Portfolio")
          return `${URL_PORTFOLIO}/${portfolioId}${URL_SEARCH_CHANGE_REQUEST}`;
        break;
      }
      case "MeetingRegistry":{
        var startDate = moment().startOf("month").format("YYYY-MM-DD");
        var endDate = moment().endOf("month").format("YYYY-MM-DD");
        return `${URL_SEARCH_MEETING_REGISTERY}StartDate=${startDate}&EndDate=${endDate}&searchTerm=`;
      }

      case "Project": {
        if (parentType === "Client")
          return `${URL_SEARCH_PROJECTS}&clientId=${clientId}&searchTerm=`;
        if (parentType === "Project")
          return `${URL_SEARCH_PROJECTS}&searchTerm=`;
        if (parentType === "Portfolio")
          return `${URL_SEARCH_PROJECTS}&portfolioId=${portfolioId}&searchTerm=`;
        if (parentType === "Program")
          return `${URL_SEARCH_PROJECTS}&programId=${programId}&searchTerm=`;
        break;
      }
      case "Scope": {
        if (parentType === "Scope") return `${BASE_URL}/Scopes?searchTerm=`;
        if (parentType === "Program")
          return `${URL_PROGRAM}${programId}/Scopes?searchTerm=`;
        if (parentType === "Project")
          return `${URL_PROJECTS}/${projectId}/Scopes?searchTerm=`;
        if (parentType === "Portfolio")
          return `${URL_PORTFOLIO}/${portfolioId}/Scopes?searchTerm=`;
        break;
      }

      case "Risk": {
        if (parentType === "Risk") return `${URL_RISK}?searchTerm=`;
        if (parentType === "Program")
          return `${URL_PROGRAM}${programId}${URL_SEARCH_RISK}`;
        if (parentType === "Project")
          return `${URL_PROJECTS}/${projectId}${URL_SEARCH_RISK}`;
        if (parentType === "Portfolio")
          return `${URL_PORTFOLIO}/${portfolioId}${URL_SEARCH_RISK}`;
        if (parentType === "Severity")
          return `${URL_RISK}/?Severity=eq:${severityFilter}&searchTerm=`;
        break;
      }
      case "Allocated Resources": {
        if (parentType === "Client")
          return `${URL_CLIENT_RESOURCES(clientId)}?searchTerm=`;
        if (parentType === "Program")
          return `${URL_PROGRAM_RESOURCES(programId)}?searchTerm=`;
        if (parentType === "Project")
          return `${URL_PROJECT_RESOURCES(projectId)}?searchTerm=`;
        if (parentType === "Portfolio")
          return `${URL_PORTFOLIO_RESOURCES(portfolioId)}?searchTerm=`;
        break;
      }
      case "Communication Plan": {
        if (parentType === "Communications")
          return `${BASE_URL}${URL_SEARCH_COMMUNICATION_PLAN}`;
        if (parentType === "Client")
          return `${URL_CLIENT}${clientId}/${URL_SEARCH_COMMUNICATION_PLAN}`;
        if (parentType === "Program")
          return `${URL_PROGRAM}${programId}/${URL_SEARCH_COMMUNICATION_PLAN}`;
        if (parentType === "Project")
          return `${URL_PROJECTS}/${projectId}/${URL_SEARCH_COMMUNICATION_PLAN}`;
        if (parentType === "Portfolio")
          return `${URL_PORTFOLIO}/${portfolioId}/${URL_SEARCH_COMMUNICATION_PLAN}`;
        break;
      }
      case "Tasks":
        return `${URL_TASK}${scopeId}${URL_SEARCH_TASK}`;
      case "Client":
        return `${URL_SEARCH_CLIENT}`;
      case "Portfolio": {
        if (parentType === "Client")
          return `${URL_CLIENT}${clientId}${URL_CLIENT_PORTFOLIOS}?searchTerm=`;
        if (parentType === "Portfolio") return `${URL_SEARCH_PORTFOLIO}`;
        break;
      }
      case "Program": {
        if (parentType === "Portfolio")
          return `${URL_CLIENT_PROGRAMS}?portfolioId=${portfolioId}&searchTerm=`;
        if (parentType === "Client")
          return `${URL_CLIENT_PROGRAMS}?clientId=${clientId}&searchTerm=`;
        if (parentType === "Program")
          return `${URL_CLIENT_PROGRAMS}?&searchTerm=`;
        break;
      }
      case "Shift": {
        return `${URL_SHIFTS}?&searchTerm=`;
      }
      case "PurchaseOrder": {
        return `${URL_PROJECT_PURCHASE_ORDERS(projectId)}?&searchTerm=`;
      }
      case "InvoiceRegistry": {
        return `${URL_PROJECT_INVOICE_REGISTRY(projectId)}?&searchTerm=`;
      }
      case "Decision": {
        if (parentType === "Project")
          return `${URL_PROJECT_DECISION_LOG(projectId)}?searchTerm=`;
        if (parentType === "Program")
          return `${URL_PROGRAM_DECISION_LOG(programId)}?searchTerm=`;
        break;
      }
      default:
        return "";
    }
  };
  */
  useEffect(() => {
    if (!search) {
      setSearch("");
    }
  }, [search]);

  return (
    <div className={`${styles.searchStylesWrapper} ${searchWd}`}>
      <input
        className={`${styles.searchStyles}  ${customClassSearch} `}
        type="search"
        placeholder="Search"
        value={search}
        disabled={isDisabled}
        onChange={(e) => handleChange(e.target.value)}
      />
      <span className={`${styles.searchIcon} d-inline-flex `}>
        <SearchIcon />
      </span>
    </div>
  );
};
export default Search;
